import { setAppType } from "@funded-here-interface/common/src/constant/appType";
import React from "react";

import "./index.css";
import ReactDOM from "react-dom/client";

import App from "./App";

setAppType("investor");

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
